import React, {useState} from 'react';
import {TextField} from "../../elements/TextField/TextField";
import {Button} from "../../elements/Button/Button";
import {Paragraph} from "../../elements/Paragraph/Paragraph";

const StoreLocator = ({ stores, maps_api_key }) => {
    const defaultMapProps = {
        center: {
            lat: -33.8688,
            lng: 151.2093
        },
        zoom: 10
    };

    return (
        <div className="store-locator min-h-[40vh] flex flex-row flex-auto p-2 my-4">
            <div className="store-list px-4 w-full">
                <div className={'field w-full py-2'}>
                    <TextField id={'search'} placeholder={'Type a postcode or address'} value={undefined} />
                </div>

                {stores && stores.map((store, index) => (
                    <div key={index} className="store my-4" x-data="{show_details:false}">
                        <h2>{store.settings.name}</h2>

                        <div className={'button-container flex flex-auto my-4'} x-on:click="show_details = !show_details">
                            <Button type={'button-secondary'} label={'Show store details'} onClick={undefined} />
                        </div>

                        <div x-show="show_details" className={"store_details slide-in-element"}>
                            <Paragraph text={store.settings.address} />
                            <Paragraph text={store.settings.telephone} />
                            <div className="opening-hours" dangerouslySetInnerHTML={{__html: store.settings.hours.replace(/\n/g, '<br />')}}/>
                        </div>

                    </div>
                ))}
            </div>
            <div className="store-map w-full max-h-[40vh]">

            </div>
        </div>
    );
}

const StoreMarker = ({ text, lat, lng }) => {
    return (
        <div className="store-marker">
            <div className={' bg-white rounded-full text-black'}>
                {text}
            </div>
        </div>
    );
};

export default StoreLocator;